import { inject } from "../ng";
import classes from "./header.module.css";
import { Label } from "./label";

declare global {
	interface Window {
		fcWidget: {
			isInitialized(): boolean;
			init(options: {
				token: string;
				host: string;
				externalId: string;
				config: {
					headerProperty: {
						hideChatButton: boolean;
					};
				};
			}): void;

			isOpen(): boolean;
			open(): void;
			close(): void;
		};
	}
}

const chat = {
	_init() {
		window.fcWidget.init({
			// shared token for all apps and environments
			token: "797ed190-4ef3-4faa-81f8-367d7ba5e6dc",
			host: "https://wchat.freshchat.com",
			// required, supposedly
			externalId: inject("UserProvider").getUser().userName,
			config: {
				headerProperty: {
					hideChatButton: true,
				},
			},
		});
	},
	_promise: undefined as Promise<Window["fcWidget"]> | undefined,
	_import() {
		if (this._promise) {
			return this._promise;
		}

		this._promise = new Promise((resolve, reject) => {
			const script = document.createElement("script");
			script.src = "https://wchat.freshchat.com/js/widget.js";
			document.head.append(script);

			const controller = new AbortController();
			const options: AddEventListenerOptions = {
				once: true,
				// AbortSignals can be used so we don't have to store our listeners in variables.
				signal: controller.signal,
			};
			const cleanup = () => {
				controller.abort();
				this._promise = undefined;
			};

			script.addEventListener(
				"load",
				() => {
					cleanup();
					this._init();
					resolve(window.fcWidget);
				},
				options,
			);

			script.addEventListener(
				"error",
				(event) => {
					cleanup();
					reject(event.error);
				},
				options,
			);
		});

		return this._promise;
	},
	_toggle() {
		if (!window.fcWidget.isInitialized()) {
			this._init();
		}
		if (window.fcWidget.isOpen()) {
			window.fcWidget.close();
		} else {
			window.fcWidget.open();
		}
	},
	toggle() {
		if (!window.fcWidget) {
			if (this._promise) {
				return;
			}
			this._import().then(this._toggle);
			return;
		}
		this._toggle();
	},
};

chat._toggle = chat._toggle.bind(chat);
chat.toggle = chat.toggle.bind(chat);

export function Chat() {
	return (
		<button className={classes.item} type="button" onClick={chat.toggle}>
			<Label icon="/img/nav-freshchat.svg">Chat</Label>
		</button>
	);
}
